import * as React from 'react';
import ConfirmBoxButton from '../ConfirmBoxButton';
import ModalFooter from "../../components/ModelPopUp/modalFooter";
import { connect } from 'react-redux';
import AppLoader from "../AppLoader";
import './styles.scss';

const ConfirmationTextBox = (props) => {
    const {
        header,
        class: className,
        message,
        messageTextClass,
        footerClass,
        cancelText,
        isLogoFooter,
        onCancelClick,
        onRemoveClick,
        removeButtonText,
        onConfirmClick,
        confirmationText,
        confirmButtonClass,
        hideCancel,
        bothButton,
        middleText,
        isLoading,
    } = props;

    return (
        <React.Fragment>
            {header && (
                <div className="modalHeader">
                    <h1>{header}</h1>
                </div>
            )}
            <div className={className ? className : "exz-confirmation-box modalBody"}>
                {message ? (
                    <div
                        className={messageTextClass || "alignMiddle rowSpaceBetween modalHeading"}
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                ) : null}
            </div>
            {isLoading && <AppLoader isLoading={true} />}
            {footerClass ? (
                <ModalFooter
                    closeButtonText={cancelText}
                    isLogoFooter={isLogoFooter}
                    onClose={onCancelClick}
                    onRemoveClick={onRemoveClick}
                    removeButtonText={removeButtonText}
                    onConfirmClick={onConfirmClick}
                    successButtonText={confirmationText}
                    successButtonClass={confirmButtonClass}
                />
            ) : (
                <ConfirmBoxButton
                    onCancelClick={onCancelClick}
                    onConfirmClick={onConfirmClick}
                    hideCancel={hideCancel}
                    confirmText={confirmationText}
                    bothButton={bothButton}
                    middleText={middleText}
                    cancelText={cancelText}
                />
            )}
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    isLoading: state.isLoading,
});

const mapDispatchToPros = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToPros)(ConfirmationTextBox);
